import { RemoveTicketLinkRequest, RemoveTicketLinkResponse } from "@functions-types";
import { makeCloudFunction } from "../makeCloudFunction";

export const removeTicketLink = makeCloudFunction<
  RemoveTicketLinkRequest,
  RemoveTicketLinkResponse
>("ticketLink", "removeTicketLink");
